export const compareStrings = (string1?: string, string2?: string): number => {
  if (string1 === undefined && string2 === undefined)
    return 0;
  else if (string1 === undefined)
    return -1;
  else if (string2 === undefined)
    return 1;
  else
    return string1.localeCompare(string2);
}
